
import React, { useMemo } from 'react'
import { FieldErrorsImpl, Path, RegisterOptions, Controller, Control, ControllerRenderProps } from "react-hook-form";
import colors from '../../assets/colors';
import Select, { GroupBase, OptionsOrGroups } from 'react-select';
import { object_equals } from '../../common/Utils';

type Props<FieldValues, TValue> = {
    containerStyle?: React.CSSProperties
    label: string,
    options: OptionsOrGroups<{
        label: string;
        value: TValue;
    }, GroupBase<{
        label: string;
        value: TValue;
    }>>
    formProps: {
        errors: Partial<FieldErrorsImpl<{ [x: string]: any; }>>
        name: Path<FieldValues>
        options?: Partial<RegisterOptions>
        control: Control<any, any>
    }
}

const ControlledPicker = <FieldValues,TValue>({ label, formProps, containerStyle, options }: Props<FieldValues, TValue>) => {

    const errorMessage = useMemo(() => {
        const error = formProps.errors[formProps.name]
        if (!error) return ''
        if (error?.message) return error.message + ''
        if (error.type == 'pattern') return `Please enter a valid ${label}`
        return `${label} is required`
    }, [formProps.errors[formProps.name]])

    const ControllerRender = ({ field: { onChange, onBlur, value } }: {
        field: ControllerRenderProps<any, Path<FieldValues>>
    }) => {

        return (
            <Select
                value={options.find((option: any) => object_equals(option.value, value))}
                onChange={(option : any) =>onChange(option.value)}
                onBlur={onBlur}
                options={options}
                styles={{
                    placeholder: base => ({ ...base, fontSize: 12, paddingLeft: 5 }),
                    singleValue: base => ({ ...base, fontSize: 12, paddingLeft: 5 }),
                    valueContainer: base => ({ ...base, textAlign: 'start' }),
                    container: base => ({ ...base, width: '100%' }),
                    control: base => ({ ...base, borderWidth: 0, backgroundColor: colors.BLUE + '12' })
                }} />
        )
    }


    return (
        <div
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', alignSelf: 'stretch', ...containerStyle }} >
            <p style={{ color: colors.BLACK_100, fontSize: 12,fontWeight : '500', marginBottom: 6 }} >{label}</p>
            <Controller
                name={formProps.name}
                control={formProps.control}
                rules={formProps.options}
                render={ControllerRender} />

            {errorMessage && <p style={{ color: 'red', fontSize: 12, marginTop: 5 }} >{errorMessage}</p>}

        </div>
    )
}

export default ControlledPicker